module.exports = __webpack_public_path__ + "media/images/landing-pages/gcse-revision-3c6a3b865c9f192a2ca99f719776df30.png";